import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {RootState, useAppSelector} from "../../../store";
import React from "react";
import {getRandomWhyGenieArray} from "../../../store/home/Helper";
import WhyGenieGridItem from "./why-genie-grid-item/WhyGenieGridItem";
import IconButton from "@mui/material/IconButton";
import {Link as RouterLink} from "react-router-dom";
import {RoutePaths} from "../../../util/constants";
import {ExpandCircleDownOutlined} from "@mui/icons-material";

const WhyGenie = () => {
    const {t} = useTranslation()
    const homeWhyGenie = useAppSelector((state: RootState) => state.homeReducer.content.why_genie)
    const loading = useAppSelector((state: RootState) => state.homeReducer.loading)

    return (
        <Box mt={12}>
            <Typography
                variant="h4"
                color="primary"
                fontWeight={600}
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    mb: '0.75em'
                }}
            >
                {t('why_genie')}
                <IconButton
                    color="primary"
                    size="small"
                    component={RouterLink}
                    to={RoutePaths.ABOUT}
                    aria-label={t('view_about')}
                    sx={{ml: 1}}
                >
                    <ExpandCircleDownOutlined sx={{transform: 'rotate(-90deg)'}}/>
                </IconButton>
            </Typography>
            <Grid container spacing={4} justifyContent='space-evenly' mt={0}>
                {(loading ? getRandomWhyGenieArray() : homeWhyGenie).map((wg) => (
                    <WhyGenieGridItem loading={loading} item={wg} key={wg.title_en}/>
                ))}
            </Grid>
        </Box>
    )
}

export default WhyGenie
